import lscache from "lscache";
import { rafTimeOut } from "./requestAnimationFrame";
import debugEnabled from "./Debug";
import initLogins from "../Login";

const cacheName = "ajaxify";

function setCache(name, value, minutes) {
    lscache.setBucket(cacheName);
    lscache.set(name, value, minutes);
    lscache.resetBucket();
}

function getCache(name) {
    lscache.setBucket(cacheName);
    const value = lscache.get(name);
    lscache.resetBucket();
    return value;
}

function flushCache() {
    lscache.setBucket(cacheName);
    lscache.flush();
    lscache.resetBucket();
}

if (debugEnabled) {
    flushCache();
}

// window.dispatchEvent(new CustomEvent('ajaxify:init', { detail: { callback: () => {console.log('init')} } }));
window.addEventListener(
    "ajaxify:init",
    ({ detail }) => {
        const callback = detail?.callback;
        init(callback);
    },
    false,
);

// window.dispatchEvent(new CustomEvent('ajaxify:clear', { detail: { callback: () => {console.log('clear')} } }));
window.addEventListener(
    "ajaxify:clear",
    ({ detail }) => {
        flushCache();
        const callback = detail?.callback;
        if (typeof callback === "function") {
            rafTimeOut(callback, 100);
        }
    },
    false,
);

// window.dispatchEvent(new CustomEvent('ajaxify:reload', { detail: { callback: () => {console.log('reload')} } }));
window.addEventListener(
    "ajaxify:reload",
    ({ detail }) => {
        flushCache();
        const callback = detail?.callback;
        rafTimeOut(() => {
            init(callback, true);
        }, 100);
    },
    false,
);

function init(callback, force = false) {
    [...document.querySelectorAll("[data-ajaxify]")].forEach((container) => {
        const data = container.dataset;
        const replace = data.inside == undefined;

        ajaxify({
            url: data.ajaxify,
            element: container,
            target: container,
            replace,
            event: data.event,
            remove: false,
            force,
            callback,
        });
    });
}

function setHtml(target, html, replace, callback, event) {
    if (replace) {
        target.outerHTML = html;
    } else {
        target.innerHTML = html;
    }
    if (typeof callback === "function") {
        callback();
    }
    if (event === "initLogins") {
        initLogins();
    } else if (typeof event === "string") {
        window.dispatchEvent(new Event(event));
    }
}

function ajaxify({ url, element, target, replace, callback, event, remove, force }) {
    if (!target) {
        target = element;
    }
    if (!url && remove) {
        element.remove();
    }

    if (!debugEnabled && !force) {
        const cache = getCache(url);
        if (cache && typeof cache === "string") {
            setHtml(target, cache, replace, callback, event);
            return;
        }
    }

    fetch(url, { cache: force ? "reload" : "default" })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.text();
        })
        .then((html) => {
            if (html) {
                if (!debugEnabled) {
                    setCache(url, html, 30);
                }
                setHtml(target, html, replace, callback, event);
            } else if (remove) {
                element.remove();
            }
        })
        .catch(() => {
            if (remove) {
                element.remove();
            }
        });
}

init();

export { ajaxify };
